/* global common, footer, tracker, CesRating, dayjs */
/* eslint no-unused-vars: ["error", { "varsIgnorePattern": "AskAQuestion" }] */

import TravelAgentPopup from '@atomic/organisms/_common/travel_agent/travel-agent-popup';
import {
  checkString,
  generateAppLink,
  libInit,
  loadJs,
  parameters,
  scriptUrl,
  sendGoogleEvent,
  sendRequest,
} from '@html/_common/utils';
import { travellerEnquiryStore } from '@html/_common/footer_script';
import AMCommonMonthSelector from '@atomic/molecules/_common/month-selector/month-selector';
import AMCommonQuantity from '@atomic/molecules/_common/quantity/quantity';

export default function AskAQuestion() {
  this.selectors = {
    followConversation: '#ask_popup_success .js-aa-btn--conversation',
    displayStandard: '.js--display-standard',
    displayOBSInitial: '.js--display-obs-initial',
    displayOBSSubmitted: '.js--display-obs-submitted',
    callTimeForm: '.js-ao-obs-call-time',
    callTimeButton: '.js-aa-btn--contact-time',
    enquiryId: '.js-ao-obs-call-time__form input[name="enquiry_id"]',
    enquiryCode: '.js-ao-obs-call-time__form input[name="enquiry_code"]',
    callTimeFrom: '.js-ao-obs-call-time__form select[name="call_time_from"]',
    callTimeTo: '.js-ao-obs-call-time__form select[name="call_time_to"]',
    callDate: '.js-ao-obs-call-time__form select[name="call_date"]',
    callPhone: '.js-ao-obs-call-time__form input[name="call_phone"]',
    wrapper: '.js-ao-common-ask-form__overlay',
    closeBtn: '.js-ao-common-ask-form-popup__close',
    form: '.js-ao-common-ask-form',
    date: '.js-common-ask-form-date',
    approxDate: '.js-common-ask-form-approximate_date',
    roomActive: 'ao-common-ask-form__stateroom-rooms-active',
    messageBox: '.js-ao-clp-question__message',
  };
  this.travelAgentPopup = null;
  this.popupLoading = false;
  this.initialized = false;
  this.askType = 'default';
  this.largeGroup = 4;

  this.common = {};
  this.footer = {};

  if (typeof common !== 'undefined') {
    this.common = common;
  } else if (typeof sendGoogleEvent !== 'undefined') {
    this.common = {
      sendGoogleEvent,
      sendRequest,
      checkString,
      libInit,
      loadJs,
      scriptUrl,
      parameters,
      generateAppLink,
    };
  }

  if (typeof footer !== 'undefined') {
    this.footer = footer;
  } else if (typeof travellerEnquiryStore !== 'undefined') {
    this.footer = {
      travellerEnquiryStore,
    };
  }

  this.checkEmail = (email, id = '', silentNotification = false) => {
    if (!email) {
      return;
    }

    this.common.sendRequest('/api/b2b/check/email', { email }, (data) => {
      const headerElement = $(this.selectors.form)
        .closest('.scout-component__modal-dialog')
        .find('.scout-component__modal-heading');
      if (!data.is_b2b) {
        $(this.selectors.form)
          .find('[name="email"][type="email"]')
          .removeAttr('data-email');
        if (headerElement.data('original-header')) {
          headerElement.text(headerElement.data('original-header'));
        }
        return;
      }
      if (!silentNotification) {
        this.travelAgentPopup.open(email, id);
      } else {
        if (!headerElement.data('original-header')) {
          headerElement.data('original-header', headerElement.text());
        }

        headerElement.text('⚠️ On Behalf of a Travel Agent');
        $(this.selectors.form)
          .find('[name="email"][type="email"]')
          .data('email', email);
      }
    });
  };

  this.listenEmail = ($form, id = '') => {
    const $email = $form.find('input[name="email"]');
    this.travelAgentPopup = new TravelAgentPopup(
      id,
    ).init();
    let interval = null;
    $email.on('blur change', (e) => {
      if (
        this.travelAgentPopup.checkCurrentEmail(
          e.target.value,
        )
      ) return;
      if (interval) {
        clearTimeout(interval);
      }
      interval = setTimeout(() => {
        this.checkEmail(
          e.target.value,
          id,
          $email.data('silent-notifications'),
        );
      });
    });
  };

  this.validateForm = ($form, fieldsToValidate) => {
    const { isFieldValid } = this;
    return fieldsToValidate.reduce((acc, [fieldName, validationFn]) => {
      const isValid = isFieldValid(
        $form.find(`[name=${fieldName}]`),
        validationFn,
      );
      return acc && isValid;
    }, true);
  };

  this.askSubmit = ($form, tour, successCallback) => {
    const {
      largeGroup,
      selectors: {
        followConversation,
        roomActive,
        form,
        enquiryId,
        enquiryCode,
      },
      validateForm,
      manageAskFormView,
      togglePopup,
      showSuccessPopup,
    } = this;

    const tourId = $.trim($form.find('input[name="tour_id"]')
      .val()) || 0;
    const tourOperatorName = $.trim($form.find('input[name="tour_operator_name"]')
      .val()) || '';
    const price = $.trim($form.data('price')) || 0;
    const hasServiceFee = $.trim($form.find('input[name="has_service_fee"]')
      .val()) || false;
    const serviceFee = $.trim($form.find('input[name="service_fee"]')
      .val()) || 0;
    let question = $.trim($form.find('textarea')
      .val()) || '';
    const email = $form.find('input[name="email"]').length > 0
      ? $.trim($form.find('input[name="email"]')
        .val())
      : null;
    const $phoneInput = $form.find('input[name="phone"]');
    const fName = $form.find('input[name="first_name"]')
      .val();
    const lName = $form.find('input[name="last_name"]')
      .val();
    const phone = $.trim($phoneInput.val());
    const $currency = $form.find('select[name="currency"]');
    const $customerIp = $form.find('select[name="customer_ip"]');
    const $date = $form.find('select[name="date"]');
    const $approxDate = $form.find('input[name=approximate_date]');
    const $stateroom = $form.find('input[name="stateroom"]');
    const $stateroomChecked = $form.find('input[name="stateroom"]:checked');
    const $room = $form.find('select[name="room"]');
    const numberOfAdultTravellers = parseInt($form.find('input[name=pax]')
      .val(), 10) || 1;
    const numberOfChildrenTravellers = parseInt($form.find('input[name=children]')
      .val(), 10) || 0;
    const $doubleOptIn = $form.find('input[name="double_opt_in"]');
    const $doubleOptInChecked = $form.find(
      'input[name="double_opt_in"]:checked',
    );
    const $past = $form.find('input[name="in-the-past"]');
    const $submitButton = $('#ask_popup button[type="submit"]');
    const $booktype = $form.find('input[name=booktype]:checked');
    const $hiddenBookType = $form.find('input[type=hidden][name=booktype]');
    const userCurrency = $form.data('currency') || 'EUR';
    const isRiverQuote = $form.hasClass('river-cruise');
    const isPrivateRequest = ($booktype.length && $booktype.val() === 'private') || $hiddenBookType.length === 1;
    const isGeneralQuestion = $form.hasClass('general');
    const { min_pax: minPax } = this.tourFunctions.getPrivateConditions();
    const totalPax = numberOfAdultTravellers + numberOfChildrenTravellers;

    const enquirySource = $form.find('input[name="enquiry_source"]')
      .val() || 'tr';

    const csrf = $form.find('#js-ao-settings-security-input').val() || '';
    const csrfInputName = $form.find('#js-ao-settings-security-input').attr('name') || 'tr_csrf_cookie_name';

    const fieldsToValidate = [
      ['first_name'],
      ['email', (val) => !!val && (this.common.func ? this.common.func.checkString(val, 'email') : this.common.checkString(val, 'email'))],
      ['phone', (val) => (!isPrivateRequest && totalPax < largeGroup ? true : !!val)],
      ['message', (val) => isRiverQuote || !!val],
    ];
    const customFields = this.getCustomFieldsValues($form);

    if (!isGeneralQuestion) {
      fieldsToValidate.push(
        ...[
          [
            'pax',
            (val) => {
              if (isRiverQuote) {
                return true;
              }
              const $children = $form.find('input[name=children]');
              const pax = parseInt(val, 10) + parseInt($children.val(), 10);
              return !isPrivateRequest || pax >= minPax;
            },
          ],
          [
            'children',
            (val) => {
              if (isRiverQuote) {
                return true;
              }
              const $pax = $form.find('input[name=pax]');
              const pax = parseInt(val, 10) + parseInt($pax.val(), 10);
              return !isPrivateRequest || pax >= minPax;
            },
          ],
          ...(isRiverQuote
            ? [
              [
                'stateroom',
                () => !isRiverQuote
                  || !$form
                    .find('[name=stateroom]')
                    .parents('.rooms')
                    .hasClass(roomActive)
                  || $form.find('[name="stateroom"]:checked').length,
              ],
              [
                'room',
                (val) => !isRiverQuote
                  || !$form
                    .find('[name=room]')
                    .parents('.rooms')
                    .hasClass(roomActive)
                  || !!val,
              ],
              ['phone'],
            ]
            : [['approximate_date', (val) => !isPrivateRequest || !!val]]),
        ],
      );
    }

    const isFormValid = validateForm($form, fieldsToValidate);

    if (!isFormValid) {
      const errorMessage = $(form)
        .data('validation-failed');
      if (errorMessage) {
        alert(errorMessage); // eslint-disable-line
      }
      $submitButton.html($submitButton.data('button-text'));
      return;
    }

    if (
      $stateroom.length > 0
      && $stateroomChecked.length > 0
      && $stateroom.parents('.rooms')
        .hasClass(roomActive)
    ) {
      const stateroomPart = $(form)
        .data('comment-stateroom');
      question = `${question ? `${question}\n\n` : ''}${stateroomPart.replace(
        '%stateroom%',
        $stateroomChecked.val(),
      )}`;
    }

    if ($past.length && $past.filter(':checked').length) {
      question = (question ? `${question}\n\n` : '')
        + $('label[for="in-the-past"]')
          .text()
          .trim();
    }

    if (typeof tracker !== 'undefined') {
      tracker('addEvent', 'tracker', 'email', email, {});
    }

    const data = {
      ...customFields,
      type: 't',
      id: tourId,
      hasServiceFee,
      serviceFee,
      email,
      details_phone: phone,
      first_name: fName,
      last_name: lName,
      source: enquirySource,
      source_id: 0,
      pax: numberOfAdultTravellers,
      pax_children: numberOfChildrenTravellers,
      details_type: 4,
      double_opt_in: $doubleOptIn.length ? $doubleOptInChecked.length : 1,
      request: question,
      note: tour.note || '',
      date:
        $date.length > 0 && $date.val().length === 10 ? $date.val() : null,
      display_dates_popup: false,
      booktype: (isRiverQuote ? 'river' : $booktype.val()) || 'group',
      [csrfInputName]: csrf,
    };

    if (isGeneralQuestion) {
      data.comment = question;
    }

    //  on behalf of TA
    if (
      $(this.selectors.form)
        .find('[name="email"][type="email"]')
        .data('email')
    ) {
      data.as_ta = true;
    }

    if (isRiverQuote && $room.parents('.rooms')
      .hasClass(roomActive)) {
      data.room = $room.val();
    }

    if (isPrivateRequest) {
      data.approximate_date = $approxDate.val();
    }

    /* additional fields from super-admin (currency, source) */
    if ($currency.length > 0) {
      data.currency = $currency.val();

      if ($customerIp.length) {
        data.customer_ip = $customerIp.val();
      }
    }

    $submitButton.attr('disabled', true);
    const apiErrorMessage = 'Something went wrong when submitting your question. Please try again later or reach out to customer support.';
    this.common.sendRequest($form.attr('action'), data, (requestData) => {
      $submitButton.removeAttr('disabled');

      if (requestData.status !== 'OK') {
        alert(apiErrorMessage);
        $submitButton.removeAttr('disabled');

        return false;
      }

      let actionValue = 'Question Asked';
      if (isRiverQuote) {
        actionValue += ' - Cruise Quote';
      } else if (tour.note) {
        actionValue += ' - General';
      }

      if (requestData.id) {
        this.common.sendGoogleEvent('Ask A Question', actionValue, tour.name, {
          tourID: tourId,
          tourPrice: price,
          tokenValue: price,
          pax: 1,
          currencyCode: userCurrency,
          ampEventName: 'ask_question_form_completed',
          operator_name: tourOperatorName,
          ask_question_type: isGeneralQuestion ? 'general' : 'tour',
          service_fee: serviceFee,
          has_service_fee: hasServiceFee,
          question_id: requestData.id,
        });

        const askAQuestionAction = isGeneralQuestion
          ? 'General Question'
          : 'Tour Question';

        this.common.sendGoogleEvent(
          'Enquiry Created',
          `${isPrivateRequest ? 'Private Request' : askAQuestionAction}`,
          requestData.id,
        );
      }

      if (!$doubleOptIn.length || $doubleOptInChecked.length) {
        this.common.sendGoogleEvent(
          'Newsletter - Signup',
          'SignedUp',
          'Question',
          {
            ampEventName: 'newsletter_subscribed',
          },
        );
      }

      if (
        typeof successCallback === 'function'
        && successCallback(requestData.href, data)
      ) {
        return true;
      }

      $(followConversation)
        .attr('href', requestData.href);

      if (requestData.isOBS) {
        $('.js--link-conversation')
          .attr('href', requestData.href);
        $(enquiryId)
          .attr('value', requestData.id);
        $(enquiryCode)
          .attr('value', requestData.code.split('-')[1]);
      }
      manageAskFormView({ isOBS: requestData.isOBS });
      togglePopup(false);

      if (requestData.has_nps_record) {
        $('#ask_popup_success .js-ao-common-nps')
          .remove();
      }

      if (tour.note) {
        showSuccessPopup(email, 'Contact Page');
      } else {
        showSuccessPopup(email);
      }

      this.footer.travellerEnquiryStore.handleEnquiryCreated(requestData.href);

      if (typeof onEnquiryCreatedGlobal === 'function') {
        onEnquiryCreatedGlobal(); // eslint-disable-line
      }

      return true;
    }, {}, () => {
      alert(apiErrorMessage);
      $submitButton.removeAttr('disabled');
    });
  };

  this.getCustomFieldsValues = ($form) => {
    const values = Object.fromEntries(new FormData($form[0]));
    const result = {};
    Object.keys(values).forEach((key) => {
      if (key.startsWith('cf-') || key.startsWith('cfc-')) {
        result[key] = values[key];
      }
    });
    return result;
  };

  this.manageAskFormView = ({
    isOBS = false,
    contactTimeSent = false,
  }) => {
    const {
      submitCallTime,
      selectors: {
        displayStandard,
        displayOBSInitial,
        displayOBSSubmitted,
        callTimeForm,
      },
    } = this;

    if (!isOBS) {
      $(`${displayOBSInitial}, ${displayOBSSubmitted}`)
        .hide();
      $(displayStandard)
        .show();
    } else if (isOBS && !contactTimeSent) {
      $(`${displayStandard}, ${displayOBSSubmitted}`)
        .hide();
      $(displayOBSInitial)
        .show();
      const $form = $(`${callTimeForm}__form`);
      $form.on('submit', (event) => {
        event.preventDefault();
        submitCallTime($(event.currentTarget));
      });
    } else {
      $(`${displayStandard}, ${displayOBSInitial}`)
        .hide();
      $(displayOBSSubmitted)
        .show();
    }
  };

  this.getCallTimeFormValues = () => {
    const {
      enquiryId,
      enquiryCode,
      callTimeFrom,
      callTimeTo,
      callDate,
      callPhone,
    } = this.selectors;

    return {
      enquiryIdValue: $(enquiryId)
        .val(),
      enquiryCodeValue: $(enquiryCode)
        .val(),
      callPhoneValue: $(callPhone)
        .val(),
      callDateValue: $(callDate)
        .val(),
      callTimeFromValue: $(callTimeFrom)
        .val(),
      callTimeToValue: $(callTimeTo)
        .val(),
    };
  };

  this.submitCallTime = ($form) => {
    const {
      validateForm,
      getCallTimeFormValues,
      manageAskFormView,
      selectors: { callTimeButton },
    } = this;

    const formValues = getCallTimeFormValues();
    const fieldsToValidate = [
      ['call_phone'],
      ['call_date'],
      ['call_time_from', (val) => val && formValues.callTimeToValue],
      [
        'call_time_to',
        (val) => val
          && formValues.callTimeFromValue
          && formValues.callTimeFromValue < val,
      ],
    ];

    const isFormValid = validateForm($form, fieldsToValidate);

    if (!isFormValid) {
      const erroMessage = $form.data('validation-failed');
      if (erroMessage) {
        alert(erroMessage); // eslint-disable-line
      }
      return;
    }

    const $submitButton = $(callTimeButton);
    $submitButton.attr('disabled', true);

    if (this.common.lib) {
      this.common.lib.init('dayjs', () => {
        this.common.lib.init('dayjs_plugin_utc', () => {
          this.common.lib.init('dayjs_plugin_customParseFormat', () => {
            dayjs.extend(window.dayjs_plugin_utc);
            dayjs.extend(window.dayjs_plugin_customParseFormat);

            const formatToUTC = (time) => `${dayjs(time, 'HH:mm')
              .utc()
              .format('HH:mm')} GMT`;

            const data = {
              enquiryId: formValues.enquiryIdValue,
              code: formValues.enquiryCodeValue,
              time: {
                from: formatToUTC(formValues.callTimeFromValue),
                to: formatToUTC(formValues.callTimeToValue),
              },
              date: formValues.callDateValue,
              phone: formValues.callPhoneValue,
            };

            this.common.sendRequest(
              $form.attr('action'),
              data,
              (callbackTimeResult) => {
                $submitButton.removeAttr('disabled');
                if (!callbackTimeResult?.success) {
                  return false;
                }
                manageAskFormView({
                  isOBS: true,
                  contactTimeSent: true,
                });
                return true;
              },
              {},
              () => {
                $submitButton.removeAttr('disabled');
                return false;
              },
            );
          });
        });
      });
    } else {
      import(/* webpackChunkName: "dayjs" */'dayjs').then((dayjsMdodule) => {
        const dayjs = dayjsMdodule.default;
        import(/* webpackChunkName: "dayjs" */'dayjs/plugin/utc').then((dayjsPluginUtcmodule) => {
          const dayjsPluginUtc = dayjsPluginUtcmodule.default;
          dayjs.extend(dayjsPluginUtc);

          import(/* webpackChunkName: "dayjs" */'dayjs/plugin/customParseFormat').then(() => {
            dayjs.extend(window.dayjs_plugin_customParseFormat);
            const formatToUTC = (time) => `${dayjs(time, 'HH:mm')
              .utc()
              .format('HH:mm')} GMT`;

            const data = {
              enquiryId: formValues.enquiryIdValue,
              code: formValues.enquiryCodeValue,
              time: {
                from: formatToUTC(formValues.callTimeFromValue),
                to: formatToUTC(formValues.callTimeToValue),
              },
              date: formValues.callDateValue,
              phone: formValues.callPhoneValue,
            };

            this.common.sendRequest(
              $form.attr('action'),
              data,
              (callbackTimeResult) => {
                $submitButton.removeAttr('disabled');
                if (!callbackTimeResult?.success) {
                  return false;
                }
                manageAskFormView({
                  isOBS: true,
                  contactTimeSent: true,
                });
                return true;
              },
              {},
              () => {
                $submitButton.removeAttr('disabled');
                return false;
              },
            );
          });
        });
      });
    }
  };

  this.showSuccessPopup = (email, viewQuestionLabel) => {
    const {
      togglePopup,
      selectors: {
        wrapper,
        followConversation,
        closeBtn,
      },
      terminate,
    } = this;

    this.isSuccessStep = true;

    togglePopup(true, 'success');

    $(`${wrapper}--form`)
      .remove();

    $('body')
      .on(
        'click',
        `${closeBtn}--success, #ask_popup_success .but:not(.blue)`,
        () => {
          togglePopup(false, 'success');
          terminate();
        },
      );

    const $viewQuestionButton = $(followConversation);
    $viewQuestionButton.on('click', () => {
      this.common.sendGoogleEvent(
        'Ask A Question',
        `View your Question${viewQuestionLabel ? ' - General' : ''}`,
        viewQuestionLabel || $viewQuestionButton.data('ga-label'),
      );
    });

    const $createAccountLink = $('.js-ao-ask-popup_box--create-account');
    $createAccountLink.on('click', () => {
      this.common.sendGoogleEvent('Ask A Question', 'Create an account');
    });

    const $appStoreDownloadBadge = $('.js-ao-apps-download__app-store-badge');
    $appStoreDownloadBadge.on('click', () => {
      this.common.sendGoogleEvent(
        'Tour Detail',
        'App Download - ios',
        'Ask A Question',
      );
    });

    const $googlePlayDownloadBadge = $(
      '.js-ao-apps-download__google-play-badge',
    );
    $googlePlayDownloadBadge.on('click', () => {
      this.common.sendGoogleEvent(
        'Tour Detail',
        'App Download - android',
        'Ask A Question',
      );
    });

    const initiateCesRating = () => {
      const askQuestionCesRating = new CesRating('aaq', this.common, email);
      askQuestionCesRating.init();
    };

    if (window.CesRating) {
      initiateCesRating();
    } else {
      this.common.loadJs(this.common.scriptUrl.cesRating, initiateCesRating);
    }
  };

  this.defaultTour = {
    id: -1,
    name: window.location.href,
    note: `User comes from ${window.location.href}`,
    type: 'default',
  };

  this.riverQuoteFunctions = {
    init: ($form) => {
      const $date = $form.find('select[name="date"]');
      $date.on('change', (event) => {
        event.preventDefault();
        const { roomActive } = this.selectors;
        const $selectedDate = $(event.currentTarget);
        const $stateroom = $form.find('.stateroom');
        $stateroom.find('img')
          .remove();
        $stateroom.find('.rooms')
          .removeClass(roomActive);
        $stateroom.find('.rooms.select option')
          .not('[value="0"]')
          .remove();
        if ($selectedDate.val() === '0') {
          return;
        }

        const selectedDate = $selectedDate.val();

        $stateroom.append(
          '<img class="l" src="/im/r/pw/tr-loader-small.gif" alt="Loading...">',
        );
        this.common.sendRequest(
          '/api/popup/get-accomodations',
          {
            id: $form.find('input[name=tour_id]')
              .val(),
            date: selectedDate,
          },
          (accomodationData) => {
            if (
              accomodationData.status === 'OK'
              && accomodationData.accomodations.length > 0
            ) {
              $.each(accomodationData.accomodations, (k, room) => {
                const sign = room.price < 0 ? '-' : '+';

                $stateroom
                  .find('.rooms.select select')
                  .append(
                    `<option value='${room.name_original}'>${
                      room.name
                    } (${sign}${$form.data('currency-symbol')}${Math.abs(
                      room.price,
                    )})</option>`,
                  );
              });
              $stateroom.find('.rooms.select')
                .addClass(roomActive);
            } else {
              $stateroom.find('.rooms.labels')
                .addClass(roomActive);
            }

            $stateroom.find('img')
              .remove();
          },
        );
      });
    },
  };

  this.handlePaxChange = (event) => {
    const { form } = this.selectors;
    const $form = $(`${form}__form`);
    const isRiverQuote = $form.hasClass('river-cruise');

    if (isRiverQuote) {
      return;
    }
    const $phoneLabel = $form.find('label[for="ask-form-phone"]');
    const $phoneField = $form.find('#ask-form-phone');

    const fieldSelector = `input[name=${event.target.name === 'pax' ? 'children' : 'pax'}]`;
    const $field = $(form).find(fieldSelector);
    const additionalPax = parseInt($field.val(), 10);
    const totalPax = parseInt(event.target.value, 10) + additionalPax;

    const $booktype = $form.find('input[name=booktype]:checked');
    const isPrivateRequest = $booktype.length && $booktype.val() === 'private';
    const dataAttr = !isPrivateRequest && totalPax < this.largeGroup
      ? 'optional'
      : 'required';
    $phoneLabel.html($phoneField.data(dataAttr));
  };

  this.tourFunctions = {
    privateConditions: null,
    init: () => {
      const {
        form,
        date,
        approxDate,
      } = this.selectors;
      const $form = $(`${form}__form`);
      const onPaxChange = this.handlePaxChange.bind(this);
      let hasUserInteracted = false;

      $form.on(
        'change',
        'input[name=pax], input[name=children]',
        onPaxChange,
      );

      new AMCommonQuantity().initiate(`${form.substring(1)}__children`); // eslint-disable-line
      new AMCommonQuantity().initiate(`${form.substring(1)}__adults`); // eslint-disable-line

      if ($form.find(approxDate).length) {
        const $idField = $(
          this.selectors.form,
        )
          .find('input[name=tour_id]');
        const tourId = $idField.length ? parseInt($idField.val(), 10) : 0;

        const $booktype = $form.find('input[name=booktype]');
        const $date = $form.find(date);
        const $approxDate = $form.find(approxDate);
        const $typeSwitchAlerts = $(`${form}__type-switch-alerts`);

        $booktype.on('change', (event) => {
          const { value } = event.currentTarget;
          const $phoneField = $form.find('#ask-form-phone');
          const $phoneLabel = $form.find('label[for="ask-form-phone"]');
          if (value === 'private') {
            this.tourFunctions.fetchPrivateOptionData(
              tourId,
            );
            $date.addClass('hid');
            $approxDate.removeClass('hid');
            $typeSwitchAlerts.removeClass('hid');
            if (!hasUserInteracted) {
              const isPrivateOfTheShelf = document.querySelector('main').dataset.private === '1';
              const label = `AAQ - ${isPrivateOfTheShelf ? 'Private TDP' : 'Group TDP'}`;
              this.common.sendGoogleEvent(
                'Tour Detail',
                'Personalized Form Interaction',
                label,
              );
              hasUserInteracted = true;
            }
            $phoneLabel.html($phoneField.data('required'));
            return;
          }
          const numberOfAdultTravellers = parseInt($form.find('input[name=pax]').val(), 10) || 1;
          const numberOfChildrenTravellers = parseInt($form.find('input[name=children]').val(), 10) || 0;
          const totalPax = numberOfAdultTravellers + numberOfChildrenTravellers;
          const dataAttr = totalPax < this.largeGroup
            ? 'optional'
            : 'required';
          $phoneLabel.html($phoneField.data(dataAttr));

          $approxDate.addClass('hid');
          $date.removeClass('hid');
          $typeSwitchAlerts.addClass('hid');
        });

        new AMCommonMonthSelector().initiate({
          $container: $('.js-common-ask-form-approximate_date'),
        });
      }

      this.initTextArea();
    },
    fetchPrivateOptionData: (tourId) => {
      if (
        this.tourFunctions.privateConditions
        || !tourId
      ) {
        return;
      }

      this.common.sendRequest(
        '/api/popup/ask-question',
        {
          id: tourId,
          tourId,
          action: 'private_options',
        },
        (response) => {
          if (!response.data) {
            return;
          }
          this.tourFunctions.privateConditions = response.data;

          $(
            `${this.selectors.form}__type-switch-alerts`,
          )
            .append(response.component || '');

          if (response.data.min_pax) {
            const $el = $('.js-am-input__label-message--pax');
            const $feedback = $el.length && $el.text();
            if ($feedback) {
              $el.text($feedback.replace('%minPax%', response.data.min_pax));
            }
          }
        },
      );
    },
    getPrivateConditions: () => this.tourFunctions.privateConditions || {
      min_pax: 0,
    },
  };

  this.startEnquiryDialog = (tour, sendEvent, sendSuccessCallback) => {
    if (this.popupLoading) {
      return;
    }
    const currentTour = tour || this.defaultTour;

    if (currentTour.type !== this.askType) {
      this.askType = currentTour.type;
      if (this.initialized) {
        this.terminate(currentTour.type);
      }
    }

    const {
      wrapper,
      closeBtn,
      form,
    } = this.selectors;

    if ($(`${wrapper}--form`).length) {
      this.togglePopup(true);
      return;
    }

    const data = {
      id: currentTour.id,
    };

    if (currentTour.type) {
      data.type = currentTour.type;
      this.askType = data.type;
    }

    this.popupLoading = true;
    this.common.sendRequest('/api/popup/ask-question', data, (responseData) => {
      $('body')
        .append(responseData.component);
      const $form = $(`${form}__form`);
      $form.on('submit', (event) => {
        event.preventDefault();
        this.askSubmit(
          $(event.currentTarget),
          currentTour,
          sendSuccessCallback,
        );
      });

      if (!$form.hasClass('general')) {
        this.listenEmail(
          $form,
          'ask-tour-question',
        );
      }

      const isRiverQuote = $form.hasClass('river-cruise');

      if (sendEvent) {
        let questionAction;
        let questionLabel;

        if (sendEvent === 'contact') {
          questionAction = '';
          questionLabel = 'Contact Page';
        } else if (isRiverQuote) {
          questionAction = ' - Cruise Quote';
          questionLabel = $('main h1')
            .html()
            .trim();
        } else {
          questionAction = ' - Float button';
          questionLabel = this.common.parameters.page_type === 'tdp'
            ? $('main h1')
              .html()
            : 'Other';
        }

        this.common.sendGoogleEvent(
          'Ask A Question',
          `Ask a question open${questionAction}`,
          questionLabel,
          {
            ampEventName: 'ask_question_form_opened',
          },
        );
      }

      if (window.tracker) {
        tracker('appendParameters', data.parameters || []);
      }

      if (!currentTour.forceEnquiry) {
        const $submitButton = $('#ask_popup .js-aa-btn--submit');
        $submitButton.text($submitButton.data('button-text'));
      }

      this.togglePopup(true);

      this.popupLoading = false;
      $('body')
        .on('click', `${closeBtn}--form`, () => {
          this.togglePopup(false);
        });
    });
  };

  this.terminate = () => {
    const {
      selectors: { wrapper },
      resetToDefaults,
    } = this;
    $(`${wrapper}--form`)
      .remove();
    $(`${wrapper}--success`)
      .remove();
    resetToDefaults();
  };

  this.togglePopup = (toggle, screen = 'form') => {
    $('html')
      .toggleClass('layer', toggle);
    $('body')
      .toggleClass('layer', toggle);
    $(
      `${this.selectors.wrapper}--${screen}`,
    )
      .toggleClass('hid', !toggle);

    if (this.initialized) {
      this.initTextArea();
      return;
    }

    if (screen === 'form') {
      const { form } = this.selectors;
      const $form = $(`${form}__form`);
      const isGeneralQuestion = $form.hasClass('general');
      const isRiverQuote = $form.hasClass('river-cruise');

      if (!isGeneralQuestion) {
        this.tourFunctions.init();
      } else {
        this.initTextArea();
      }

      if (isRiverQuote) {
        this.riverQuoteFunctions.init($form);
      }
    }

    this.initialized = true;
  };

  this.initTextArea = (customSelector) => {
    const selector = customSelector || this.selectors.messageBox;
    const $msgBox = $(selector);
    if (!$msgBox.length) {
      return;
    }
    const isAutoResize = !!$msgBox.find('.scout-element__textarea-auto-resizer').length;
    if (!isAutoResize) {
      return;
    }

    $(`${selector} textarea`)
      .on('input', (e) => {
        const txtBox = e.currentTarget;
        if (isAutoResize) {
          $(txtBox)
            .parent()
            .data('replicatedValue', $(txtBox)
              .val());
        }
      });
  };

  this.isFieldValid = ($theField, validationFn = (val) => !!val) => {
    const $theWrapper = $theField.parents('.am-input');
    const errorClass = 'am-input--error';

    if (validationFn($.trim($theField.val()))) {
      return !!$theWrapper.removeClass(errorClass);
    }

    $theField.on('change paste keyup', () => {
      if (validationFn($theField.val())) {
        $theWrapper.removeClass(errorClass);
      }
    });

    return !$theWrapper.addClass(errorClass);
  };

  this.resetToDefaults = () => {
    this.initialized = false;
    this.tourFunctions.privateConditions = null;
  };
}
